import { FormItem, FormLabel, FormMessage } from "@workspace/web-ui/components/form";
import { FormControl } from "@workspace/web-ui/components/form";
import { Input } from "@workspace/web-ui/components/input";
import { AlertCircle, KeyRound, KeySquare } from "lucide-react";
import { Control, Controller, ControllerRenderProps, FieldValues, Path } from "react-hook-form"
import { FormFieldType } from "../../types";
import { PasswordInput } from "@workspace/web-ui/components/password";


interface FormFieldProps<T extends FieldValues> {
    control: Control<T>;
    name: Path<T>;
    label?: string;
    placeholder?: string;
    type?: string;
    defaultValue?: T;
    error?: string;
    className?: string;
    autoComplete?: string;
    fieldType: FormFieldType;
}

const renderField = <T extends FieldValues>(props: FormFieldProps<T> & { field: ControllerRenderProps<T, Path<T>> })=> {
  switch (props.fieldType) {
    case FormFieldType.TEXT:
      return (<Input  
        type={props.type}
        autoComplete={props.autoComplete}
        className={props.className}
        placeholder={props.placeholder}
        aria-label={props.label}
        aria-invalid={!!props.error}
        {...props.field}
      />)
    case FormFieldType.PASSWORD:
      return (<PasswordInput 
        placeholder="Enter password"
        type="password"
        autoComplete="current-password"
        className={props.className}
        aria-label="Password"
        aria-invalid={!!props.error}
        showIcon={<KeyRound size={16} />}
        hideIcon={<KeySquare size={16} />}
        {...props.field}
      />)
    default:
      return (<Input
        placeholder={props.placeholder}
        type={props.type}
        autoComplete={props.autoComplete}
        className={props.className}
        aria-label={props.label}
        aria-invalid={!!props.error}
        {...props.field}
      />)
  }
}



const FormField = <T extends FieldValues>(props: FormFieldProps<T>) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-[#1A202C] font-medium text-base">{props.label}</FormLabel>
          <FormControl>
            {renderField({ ...props, field })}
          </FormControl>
          {props.error && <FormMessage className="text-red-500 text-sm flex gap-2 items-center">
            <AlertCircle className="w-4 h-4 text-red-500" />
            {props.error}
          </FormMessage>}
        </FormItem>
      )}
    />
  )
}

export default FormField